import { Link } from 'react-router-dom';
import Logo from '../assets/images/Logo.svg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import conclusionNextStep from '../assets/images/conclusion-next-step.svg';

function Conclusion() {
  return (
    <>
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/pfasarchitecture' className='pfas-btn-white-back'>
            <div className='nav-text-back'>Previous</div>
          </Link>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>
          <Link to='/credits' className='pfas-btn-white-next-credits'>
            <div className='nav-text-next-dark'>Credits</div>
          </Link>
        </div>
      </div>
      <div className='pfas-conclusion pfas-container'>
        <Row>
          <div className='conclusion'>
            <Col xs={12} lg={6}>

            <div className='text-left'>
              <div className='slogan'>CONCLUSIONS</div>
              <div className='headline'>Outcome delivered</div>
              <ul>
                <li className='list-text'>
                  We simulated VQEs at scale on{' '}
                  <b>Kay, a high-performance computer at ICHEC</b>, and
                  implemented integration with <b>IonQ</b>’s trapped ion quantum
                  hardware.
                </li>
                <li className='list-text'>
                  We built a <b>scalable end-to-end VQE platform</b> that
                  creates parallel jobs and orchestrates their execution on the
                  HPC or quantum hardware.
                </li>
                <li className='list-text'>
                  The results show a{' '}
                  <b>dissociation curve of a molecular bond</b>, which is
                  crucial in understanding which chemical destruction pathways
                  are possible.
                </li>
                <li className='list-text'>
                  The solution can be applied to a wide range of other use cases
                  such as <b>discovery of drugs</b>,{' '}
                  <b>sustainable fertilizers</b>, and{' '}
                  <b>carbon capture methods</b>.
                </li>
              </ul>
            </div>
            </Col>
            <Col xs={12} lg={6}>

            <div className='image-right'>
              <div className='heading'>Next steps</div>
              <div className='text'>
                <ul>
                  <li className='list-text'>
                    Improving accuracy and capacity, and full geometry
                    optimization by exploring new algorithms and infrastructure.
                  </li>
                  <li className='list-text'>
                    Scaled up simulation of PFAS molecules to help design
                    destructive pathways.
                  </li>
                  <li className='list-text'>
                    Studying reactions of PFAS in the presence of catalysts.
                  </li>
                </ul>
              </div>
              <div className='conclusion-next-step'>
                <img src={conclusionNextStep} alt='vqe method' />
              </div>
            </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
}

export default Conclusion;
